import React from 'react';
import { Box, Card } from '@mui/material';
import Grid from '@mui/material/Grid';

import OverviewTotalSales from './components/biReports/OverviewTotalSales';
import OverviewMonthSales from './components/biReports/OverviewMonthSales';
import OverviewMonthCustomers from './components/biReports/OverviewMonthCustomers';
import OverviewTotalTransactions from './components/biReports/OverviewTotalTransactions';

import SalesForecastLocationList from './components/biReports/SalesForecastLocationList';
import SalesTargetLocationList from './components/biReports/SalesTargetLocationList';
import SalesTargetCategory from './components/biReports/SalesTargetCategory';

import Client from './components/Client';
import { format } from 'date-fns';

let d = new Date();
let today = format(d, 'yyyy-MM-dd');

class RapSales2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      /* locationGroups: null, */
      edit: false,
      date: today,
      tabValue: "value"
    };

    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
    if (this.props.onReady) {
      this.props.onReady();
    }
  }

  componentWillUnmount() {
  }

  /* setLocationsGroups ( groups ) {
    let a = { }
    if ( groups !== null && groups !== undefined ) {
      groups.map ( (locationGroup) => {
        a [ locationGroup.iref ] = locationGroup;
      });
      this.setState ( { locationGroups : a });
    }
  }
 */

  addDate = (event) => {
    this.setState({ date: event.target.value });
  }

  handleTabChange(event, newValue) {
    this.setState({ tabValue: newValue });
  }

  render() {
    const fullWidthChildSx = {
      width: '100%',
      minWidth: 0,
      '& > *': {
        width: '100% !important',
        maxWidth: '100% !important',
        mx: '0 !important',
        boxSizing: 'border-box',
      },
    };

    const reportCardSx = {
      height: { xs: 'auto', lg: 600 },
      minHeight: { xs: 520, sm: 560, lg: 600 },
      borderRadius: { xs: '14px', sm: '16px' },
      overflow: 'hidden',
      boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
      border: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
    };

    const reportInnerSx = {
      width: '100%',
      height: '100%',
      minWidth: 0,
      overflow: 'auto',
      boxSizing: 'border-box',
      px: { xs: 0.25, sm: 0.5 },
      py: { xs: 0.25, sm: 0.5 },
    };

    return (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          maxWidth: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          ml: {
            xs: 'calc(50% - 50vw + 4px)',
            sm: 0,
          },
          // bgcolor: '#f3f6fa',
          overflowX: 'hidden',
          pt: { xs: 0.75, sm: 1.5, md: 3 },
          pb: { xs: 1, sm: 2, md: 3 },
          px: { xs: 0.5, sm: 1, md: 2 },
          boxSizing: 'border-box',

          '& .MuiGrid-item': {
            minWidth: 0,
          },
          '& .MuiCard-root': {
            maxWidth: '100%',
            boxSizing: 'border-box',
          },
        }}
      >
        <Grid
          container
          spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
          sx={{
            width: '100%',
            maxWidth: '100%',
            m: 0,
          }}
        >
          <Grid item xs={12} sx={{ p: '0 !important' }}>
            <Grid
              container
              spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
              sx={{
                width: '100%',
                m: 0,
              }}
            >
              <Grid item lg={4} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewTotalSales />
                </Box>
              </Grid>

              <Grid item lg={4} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewTotalTransactions />
                </Box>
              </Grid>

              <Grid item lg={4} md={12} sm={12} xs={12}>
                <Grid
                  container
                  spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
                  sx={{
                    width: '100%',
                    m: 0,
                  }}
                >
                  <Grid item sm={6} xs={6} md={6} lg={6}>
                    <Box sx={fullWidthChildSx}>
                      <OverviewMonthSales />
                    </Box>
                  </Grid>

                  <Grid item sm={6} xs={6} md={6} lg={6}>
                    <Box sx={fullWidthChildSx}>
                      <OverviewMonthCustomers />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ p: '0 !important', mt: { xs: 0.75, md: 1.5 } }}>
            <Grid
              container
              spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
              sx={{
                width: '100%',
                m: 0,
              }}
            >
              <Grid item xs={12} lg={5}>
                <Card sx={reportCardSx}>
                  <Box sx={reportInnerSx}>
                    <SalesForecastLocationList />
                  </Box>
                </Card>
              </Grid>

              <Grid item xs={12} lg={7}>
                <Card sx={reportCardSx}>
                  <Box sx={reportInnerSx}>
                    <SalesTargetLocationList />
                  </Box>
                </Card>
              </Grid>

              {/* <Grid item xs={12} lg={3}>
                <Card sx={reportCardSx}>
                  <Box sx={reportInnerSx}>
                    <SalesTargetCategory />
                  </Box>
                </Card>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default RapSales2;